/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_sellerItems = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGridSeller_sellerItems">;
    readonly " $refType": "PdpRespContainer_sellerItems";
};
export type PdpRespContainer_sellerItems$data = PdpRespContainer_sellerItems;
export type PdpRespContainer_sellerItems$key = {
    readonly " $data"?: PdpRespContainer_sellerItems$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_sellerItems">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_sellerItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_sellerItems",
      "args": null
    }
  ]
};
(node as any).hash = 'ce2dcab9626125ffef79df7339eb9c41';
export default node;
